// @ts-nocheck
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RegistrationPage from '../../components/layouts/RegistrationPage';
import PrimarySubmit from '../../components/button/PrimarySubmit';
import uploadImage from '../../assets/images/upload.png';
import '../home/Terms.scss';
import '../emailVerification/Email.scss';

export default function UploadImage() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const goToReady = () => {
        navigate('/ready');
    };

    return (
        <RegistrationPage
            showBack
            footer={
                <div className='mx-auto w-full max-w-md min-[450px]:max-w-none md:mt-8'>
                    <PrimarySubmit onClick={goToReady}>{t('upload.cta')}</PrimarySubmit>
                </div>
            }
        >
            <div className='email-verify-form mx-auto w-full max-w-md min-[450px]:max-w-none text-center'>
                <img
                    src={uploadImage}
                    alt=''
                    className='mx-auto mb-4 block h-32 w-auto object-contain min-[450px]:mb-[40px]'
                />

                <h2 className='terms-panel__headline mb-3 text-center md:mb-4'>{t('upload.title')}</h2>
                <p className='terms-panel__lead mb-6 text-center'>{t('upload.subtitle')}</p>
                <p className='text-sm leading-relaxed text-[#333]'>{t('upload.body')}</p>
            </div>
        </RegistrationPage>
    );
}
